import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./style.css";

const PermissionDenied = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Check if this is a 404 (invalid URL) or permission denied
  const isInvalidUrl = !location.pathname.startsWith('/dashboard') && 
                      !location.pathname.startsWith('/manage-') && 
                      !location.pathname.startsWith('/shopping-') && 
                      !location.pathname.startsWith('/label-') && 
                      !location.pathname.startsWith('/mood-') && 
                      !location.pathname.startsWith('/document-') && 
                      !location.pathname.startsWith('/hydration') && 
                      !location.pathname.startsWith('/reminder-') && 
                      !location.pathname.startsWith('/voice-') && 
                      !location.pathname.startsWith('/multilingual-') && 
                      !location.pathname.startsWith('/translation-') && 
                      !location.pathname.startsWith('/location-') && 
                      !location.pathname.startsWith('/budget-') && 
                      !location.pathname.startsWith('/ai-') && 
                      !location.pathname.startsWith('/user-') && 
                      !location.pathname.startsWith('/wellness-') && 
                      !location.pathname.startsWith('/financial-') && 
                      !location.pathname.startsWith('/smart-') && 
                      !location.pathname.startsWith('/settings') && 
                      !location.pathname.startsWith('/profile') && 
                      !location.pathname.startsWith('/reset-') && 
                      !location.pathname.startsWith('/otp') && 
                      !location.pathname.startsWith('/forgot-') && 
                      !location.pathname.startsWith('/permission-') && 
                      location.pathname !== '/';

  const handleGoHome = () => {
    navigate("/dashboard");
  };

  return (
    <section className="page_404">
      <div className="container">
        <div className="row">	
          <div className="col-sm-12 ">
            <div className="col-sm-10 col-sm-offset-1  text-center">
              <div className="four_zero_four_bg">
                <h1 className="text-center">
                  {isInvalidUrl ? "404" : "403"}
                </h1>
              </div>
              
              <div className="contant_box_404">
                <h3 className="h2">
                  {isInvalidUrl ? "Page Not Found" : "Access Denied"}
                </h3>
                
                <p>
                  {isInvalidUrl 
                    ? "The page you are looking for is not available!" 
                    : "You don't have permission to access this module!"
                  }
                </p>
                
                <button onClick={handleGoHome} className="link_404">
                  Go to Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PermissionDenied;
